var _rect, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSelfPacedCourse = function SvgSelfPacedCourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F8C354"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.908 28.88a.037.037 0 0 0-.037.037v1.036c0 .02.016.037.037.037H26.61c.02 0 .037-.016.037-.037v-1.037a.037.037 0 0 0-.037-.037h-3.148a.149.149 0 0 1-.149-.148v-4.259a.037.037 0 0 0-.037-.037H17.24a.037.037 0 0 0-.037.037v4.259a.149.149 0 0 1-.148.148h-3.147Z",
    fill: "url(#self-paced-course_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.724 11.657a.743.743 0 0 0-.743.744v12.957c0 .41.333.743.743.743h18.513c.41 0 .744-.333.744-.743V12.4a.743.743 0 0 0-.744-.744H10.724Zm3.702 3.927c0-.02.016-.037.037-.037h11.036c.02 0 .038.017.038.037v1.037c0 .02-.017.037-.038.037H14.463a.037.037 0 0 1-.037-.037v-1.037Zm0 3.89c0-.021.016-.038.037-.038h7.147c.021 0 .038.017.038.037v1.037c0 .02-.017.037-.038.037h-7.147a.037.037 0 0 1-.037-.037v-1.037Z",
    fill: "url(#self-paced-course_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.463 15.547a.037.037 0 0 0-.038.037v1.037c0 .02.017.037.037.037H25.5c.02 0 .037-.016.037-.037v-1.036a.037.037 0 0 0-.037-.038H14.463Zm0 3.89a.037.037 0 0 0-.038.036v1.037c0 .02.017.037.037.037h7.148c.02 0 .037-.016.037-.037v-1.037a.037.037 0 0 0-.037-.037h-7.147Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.055 11.657a.074.074 0 0 0-.074.075v13.184c0 .04.033.074.074.074h13.767a.075.075 0 0 0 .068-.043l6.042-13.184a.074.074 0 0 0-.067-.106h-19.81Zm4.37 3.927c0-.02.017-.037.038-.037h11.036c.02 0 .038.017.038.037v1.037c0 .02-.017.037-.038.037H14.463a.037.037 0 0 1-.037-.037v-1.037Zm0 3.89c0-.021.017-.038.038-.038h7.147c.021 0 .038.017.038.037v1.037c0 .02-.017.037-.038.037h-7.147a.037.037 0 0 1-.037-.037v-1.037Z",
    fill: "url(#self-paced-course_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-paced-course_svg__a",
    x1: 23.037,
    y1: 29.99,
    x2: 23.037,
    y2: 24.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-paced-course_svg__b",
    x1: 9.981,
    y1: 11.657,
    x2: 34.147,
    y2: 26.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-paced-course_svg__c",
    x1: 24.284,
    y1: 24.712,
    x2: 10.376,
    y2: 11.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgSelfPacedCourse;